import React from 'react';
import { Typography } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { Tooltip } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { TaxesType } from 'utils/taxes';
import { v4 as uuidv4 } from 'uuid';

interface TaxesProps {
  taxes: TaxesType;
  label?: string;
  status?: string;
  totalTax: number;
  printMode?: boolean;
  compactMode?: boolean;
}

export default function Taxes(props: TaxesProps) {
  const { t } = useTranslation();
  const { taxes, printMode = false, totalTax, status, compactMode, label: labelProp } = props;

  const getLabel = () => {
    if (labelProp) return labelProp;
    if (status === 'completed' || status === 'submitted') return 'Taxes';
    return 'Estimated Taxes';
  };

  const label = t(getLabel());

  return (
    <>
      <Tooltip
        placement="top-end"
        title={
          <div style={{ maxWidth: 200 }}>
            {taxes.map((tax) => (
              <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }} key={uuidv4()}>
                {t('{{tax}}: ${{amount}}', { tax: t(tax.name), amount: tax.amount.toFixed(2) })}
                <br />
              </div>
            ))}
            {!(status === 'completed' || status === 'submitted') && (
              <Typography style={{ fontSize: 10 }}>
                {t('Final tax amounts will be calculated at the time of order completion')}
              </Typography>
            )}
          </div>
        }
      >
        <div>
          {!compactMode && (
            <Typography style={{ fontSize: 12, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '3px' }}>
              {!printMode && <InfoOutlined fontSize="small" />}
              {t('{{label}}: ${{totalTax}}', { label, totalTax: totalTax.toFixed(2) })}
            </Typography>
          )}
          {compactMode && <InfoOutlined fontSize="small" style={{ width: 14, margin: 8, marginRight: 2 }} />}
        </div>
      </Tooltip>
    </>
  );
}
